"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var _default = function _default(props) {
  return /*#__PURE__*/_react["default"].createElement("svg", _extends({
    version: "1.1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.5 21",
    width: "24.5",
    height: "21"
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M24,21H0.5c-0.2,0-0.3-0.1-0.4-0.3c-0.1-0.2-0.1-0.3,0-0.5l2.6-4.3l0.9,0.5L1.4,20h21.8l-2.8-4.7l0.9-0.5l3.3,5.4 c0.1,0.2,0.1,0.3,0,0.5S24.2,21,24,21z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M20.7,15.4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M18.6,11.6"
  }), /*#__PURE__*/_react["default"].createElement("rect", {
    x: "17.5",
    y: "9.5",
    transform: "matrix(0.8684 -0.4958 0.4958 0.8684 -2.8935 10.3477)",
    width: "1",
    height: "2.3"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M17.5,9.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fill: "#000000",
    d: "M15.2,5.6"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M9.6,6.2L8.7,5.7l3.1-5.4C11.9,0.1,12.1,0,12.3,0h0c0.2,0,0.3,0.1,0.4,0.3l2.9,5.1l-0.9,0.5l-2.5-4.4L9.6,6.2z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#9ECE06",
    d: "M14.2,8.4c0.4,1.6,2.4,0.8,2.6-0.1c0.3-1.4-1.1-2-3.4-1.9 c-4,0.1-9.1,3.1-9.7,8.3c-0.3,2.8,2.3,4.7,4.5,4.7c1.8-0.1,2.1-0.1,3.2-0.5c0.6-0.2,2.1-1,2.1-1.7c0-0.2-0.2-0.3-0.3-0.3 c-0.3,0-0.9,0.6-1.1,0.8c-1.1,0.6-2.4,1-3.6,0.7c-2.2-0.5-2.7-3-1.7-5.6c0.7-1.8,2.7-5.8,7.5-5.3C14.8,7.3,14.1,8,14.2,8.4"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    fill: "#9ECE06",
    d: "M19.1,13.5c0.1,0,0.2,0.2,0.1,0.3c0,0.5,0.2,0.5,0.6,0.5 c0.6,0.1,0.9-0.4,1-1.1c0-0.6-0.3-1.1-0.7-1.1c-1.3,0-2.1,2.1-2.8,3.3l0.2-0.7c0.1-0.6,0.3-1.2,0.4-1.8c0-0.6-0.2-0.8-0.6-0.8 c-0.7,0-1.3,0.6-1.8,1.2c-0.2,0.2-0.6,0.8-0.7,1.1c0,0.1,0.1,0.2,0.1,0.2c0.3,0,0.9-1.2,1.3-1.2c0.1,0,0.1,0.1,0.1,0.2 c0,0.3-0.3,1.1-0.3,1.4l-1.1,3.3l-0.1,0.4c0,0.1-0.1,0.3-0.1,0.4c0,0.2,0.3,0.2,0.4,0.2h0.3c0.2,0,0.7,0,0.8-0.1 c0.1-0.1,0.2-0.3,0.2-0.5C17.1,16,18.7,13.5,19.1,13.5"
  }));
};

exports["default"] = _default;